const element = document.querySelector("#vue-map");

if (element) {
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBbpmu8-ehhOcx3ouc6fVeZsFHM-GAJ8S8&callback=initMap";
  s.async = true;
  document.body.appendChild(s);
}
